import {
    BellIcon,
    CheckCircleIcon,
    CopyIcon,
    EditIcon,
    InfoIcon,
} from 'lucide-react-native';
import { useState } from 'react';
import { YStack } from 'tamagui';

import { AccountRow } from '../../components/rows/AccountRow';
import { BadgeRow } from '../../components/rows/BadgeRow';
import { CheckboxRow } from '../../components/rows/CheckboxRow';
import { InfoRow } from '../../components/rows/InfoRow';
import { NavigationRow } from '../../components/rows/NavigationRow';
import { SwitchRow } from '../../components/rows/SwitchRow';
import { TextRow } from '../../components/rows/TextRow';
import { H6Regular } from '../../components/text/Typography';

export const Rows = () => {
    const [checkboxChecked, setCheckboxChecked] = useState(false);
    const [switchChecked, setSwitchChecked] = useState(false);

    return (
        <YStack gap={32}>
            <YStack gap={12}>
                <H6Regular>Text Row</H6Regular>
                <YStack gap={8}>
                    <TextRow title="Email" secondaryText="user@example.com" />
                    <TextRow
                        title="Account Balance"
                        leftIcon={BellIcon}
                        secondaryText="$1,234.56"
                    />
                    <TextRow
                        title="Account Balance"
                        subtitle="Current balance"
                        secondaryText="$1,234.56"
                        secondarySubtext="Available now"
                    />
                    <TextRow
                        title="Phone Number"
                        subtitle="Contact number"
                        leftIcon={BellIcon}
                        secondaryText="(555) 123-4567"
                    />
                    <TextRow
                        title="Last Payment"
                        subtitle="Payment history"
                        secondaryText="$500.00"
                        secondarySubtext="Jan 15, 2024"
                    />
                    <TextRow
                        title="SSN"
                        subtitle="Social Security Number"
                        secondaryText="123-45-6789"
                        isPrivate={true}
                    />
                    <TextRow
                        title="Styled Secondary Text"
                        subtitle="With custom styling"
                        secondaryText="$5,000.00"
                        secondaryTextProps={{
                            color: '$green1000',
                        }}
                    />
                    <TextRow
                        title="Styled Secondary Subtext"
                        subtitle="With custom subtext styling"
                        secondaryText="$2,500.00"
                        secondarySubtext="Pending"
                        secondarySubtextProps={{
                            color: '$orange1000',
                        }}
                    />
                    <TextRow
                        title="Both Styled"
                        subtitle="Custom styling for both"
                        secondaryText="$10,000.00"
                        secondaryTextProps={{
                            color: '$green1000',
                        }}
                        secondarySubtext="Available balance"
                        secondarySubtextProps={{
                            color: '$orange1000',
                        }}
                    />
                </YStack>
            </YStack>

            <YStack gap={12}>
                <H6Regular>Navigation Row</H6Regular>
                <YStack gap={8}>
                    <NavigationRow title="Settings" href="/" />
                    <NavigationRow
                        title="Profile"
                        subtitle="View your profile"
                        href="/"
                    />
                    <NavigationRow
                        title="Notifications"
                        subtitle="Manage notifications"
                        leftIcon={BellIcon}
                        href="/"
                    />
                    <NavigationRow
                        disabled
                        title="Disabled option"
                        subtitle="Grayed out and non-interactive"
                        leftIcon={EditIcon}
                        href="/"
                    />
                </YStack>
            </YStack>

            <YStack gap={12}>
                <H6Regular>Badge Row</H6Regular>
                <YStack gap={8}>
                    <BadgeRow
                        title="Item"
                        badgeProps={{ variant: 'neutral', text: 'Action' }}
                        onPress={() => {}}
                    />
                    <BadgeRow
                        title="Item"
                        subtitle="With subtitle"
                        badgeProps={{ variant: 'neutral', text: 'Edit' }}
                        onPress={() => {}}
                    />
                    <BadgeRow
                        title="Item"
                        subtitle="With icon"
                        leftIcon={EditIcon}
                        badgeProps={{
                            variant: 'neutral',
                            text: 'Edit',
                            icon: EditIcon,
                        }}
                        onPress={() => {}}
                    />
                    <BadgeRow
                        title="Item"
                        subtitle="Warning with icon"
                        badgeProps={{
                            variant: 'warning',
                            text: 'Warning',
                            icon: CheckCircleIcon,
                        }}
                        onPress={() => {}}
                    />
                    <BadgeRow
                        title="Item"
                        subtitle="Positive variant"
                        badgeProps={{ variant: 'positive', text: 'Success' }}
                        onPress={() => {}}
                    />
                    <BadgeRow
                        title="Item"
                        subtitle="Positive with icon"
                        badgeProps={{
                            variant: 'positive',
                            text: 'Active',
                            icon: CheckCircleIcon,
                        }}
                        onPress={() => {}}
                    />
                    <BadgeRow
                        title="Item"
                        subtitle="Danger variant"
                        badgeProps={{ variant: 'danger', text: 'Delete' }}
                        onPress={() => {}}
                    />
                </YStack>
            </YStack>

            <YStack gap={12}>
                <H6Regular>Checkbox Row</H6Regular>
                <YStack gap={8}>
                    <CheckboxRow
                        title="Enable Notifications"
                        checkboxProps={{
                            checked: checkboxChecked,
                            onPress: () => {
                                setCheckboxChecked(!checkboxChecked);
                            },
                        }}
                    />
                    <CheckboxRow
                        title="Enable Notifications"
                        subtitle="Receive push notifications"
                        onPress={() => {
                            // Row press handler - could navigate or show details
                            console.log('Row pressed');
                        }}
                        checkboxProps={{
                            checked: checkboxChecked,
                            onPress: () => {
                                setCheckboxChecked(!checkboxChecked);
                            },
                        }}
                    />
                    <CheckboxRow
                        title="Enable Notifications"
                        subtitle="Receive push notifications"
                        leftIcon={BellIcon}
                        onPress={() => {
                            // Row press handler - could navigate or show details
                            console.log('Row pressed');
                        }}
                        checkboxProps={{
                            checked: checkboxChecked,
                            onPress: () => {
                                setCheckboxChecked(!checkboxChecked);
                            },
                        }}
                    />
                    <CheckboxRow
                        title="Positive Tone"
                        subtitle="With positive tone checkbox"
                        checkboxProps={{
                            checked: checkboxChecked,
                            onPress: () => {
                                setCheckboxChecked(!checkboxChecked);
                            },
                            tone: 'positive',
                        }}
                    />
                    <CheckboxRow
                        title="Positive Tone with Icon"
                        subtitle="Positive tone with left icon"
                        leftIcon={CheckCircleIcon}
                        checkboxProps={{
                            checked: checkboxChecked,
                            onPress: () => {
                                setCheckboxChecked(!checkboxChecked);
                            },
                            tone: 'positive',
                        }}
                    />
                    <CheckboxRow
                        title="Large Checkbox"
                        subtitle="Large size checkbox"
                        checkboxProps={{
                            checked: checkboxChecked,
                            onPress: () => {
                                setCheckboxChecked(!checkboxChecked);
                            },
                            size: 'large',
                        }}
                    />
                    <CheckboxRow
                        title="Large Checkbox with Icon"
                        subtitle="Large size with left icon"
                        leftIcon={BellIcon}
                        checkboxProps={{
                            checked: checkboxChecked,
                            onPress: () => {
                                setCheckboxChecked(!checkboxChecked);
                            },
                            size: 'large',
                        }}
                    />
                    <CheckboxRow
                        title="Large Positive Checkbox"
                        subtitle="Large size with positive tone"
                        onPress={() => {
                            // Row press handler - could navigate or show details
                            console.log('Row pressed');
                        }}
                        checkboxProps={{
                            checked: checkboxChecked,
                            onPress: () => {
                                setCheckboxChecked(!checkboxChecked);
                            },
                            size: 'large',
                            tone: 'positive',
                        }}
                    />
                    <CheckboxRow
                        title="Large Positive with Icon"
                        subtitle="Large size, positive tone, with icon"
                        leftIcon={CheckCircleIcon}
                        checkboxProps={{
                            checked: checkboxChecked,
                            onPress: () => {
                                setCheckboxChecked(!checkboxChecked);
                            },
                            size: 'large',
                            tone: 'positive',
                        }}
                    />
                    <CheckboxRow
                        title="Disabled Checkbox"
                        subtitle="Disabled state"
                        checkboxProps={{
                            checked: checkboxChecked,
                            onPress: () => {
                                setCheckboxChecked(!checkboxChecked);
                            },
                            disabled: true,
                        }}
                    />
                </YStack>
            </YStack>

            <YStack gap={12}>
                <H6Regular>Switch Row</H6Regular>
                <YStack gap={8}>
                    <SwitchRow
                        title="Dark Mode"
                        switchProps={{
                            isChecked: switchChecked,
                            onCheckedChange: setSwitchChecked,
                        }}
                    />
                    <SwitchRow
                        title="Dark Mode"
                        subtitle="Use dark theme"
                        switchProps={{
                            isChecked: switchChecked,
                            onCheckedChange: setSwitchChecked,
                        }}
                    />
                    <SwitchRow
                        title="Notifications"
                        subtitle="Enable push notifications"
                        leftIcon={BellIcon}
                        switchProps={{
                            isChecked: switchChecked,
                            onCheckedChange: setSwitchChecked,
                        }}
                    />
                </YStack>
            </YStack>

            <YStack gap={12}>
                <H6Regular>Account Row</H6Regular>
                <YStack gap={8}>
                    <AccountRow
                        accountName="Checking Account"
                        isJointAccount={false}
                        isJointMembership={false}
                        balance="$5,234.56"
                    />
                    <AccountRow
                        accountName="Savings Account"
                        isJointAccount={true}
                        isJointMembership={true}
                        balance="$12,500.00"
                        accountIcon="home"
                        onPress={() => {
                            console.log('Account row pressed');
                        }}
                    />
                </YStack>
            </YStack>

            <YStack gap={12}>
                <H6Regular>Info Row</H6Regular>
                <YStack gap={8}>
                    <InfoRow title="Email" value="user@example.com" />
                    <InfoRow
                        title="Account Number"
                        value="1234567890"
                        trailingIcon={CopyIcon}
                        onPress={() => {
                            console.log('Copy account number');
                        }}
                    />
                    <InfoRow
                        title="Routing Number"
                        value="987654321"
                        trailingIcon={CopyIcon}
                        onPress={() => {
                            console.log('Copy routing number');
                        }}
                    />
                    <InfoRow title="SSN" value="123-45-6789" isPrivate={true} />
                    <InfoRow title="Account Type" value="Checking" />
                    <InfoRow
                        title="Ownership"
                        value="Joint"
                        trailingIcon={EditIcon}
                        onPress={() => {
                            console.log('Edit ownership');
                        }}
                    />
                    <InfoRow
                        title="Nickname"
                        value="My Primary Account"
                        trailingIcon={EditIcon}
                        onPress={() => {
                            console.log('Edit nickname');
                        }}
                    />
                    <InfoRow
                        title="Status"
                        value="Active"
                        badges={[{ variant: 'positive', text: 'Verified' }]}
                    />
                    <InfoRow
                        title="Account Status"
                        value="Pending"
                        badges={[
                            { variant: 'warning', text: 'Review' },
                            { variant: 'neutral', text: 'New' },
                        ]}
                    />
                    <InfoRow
                        title="Balance"
                        value="$10,234.56"
                        badges={[{ variant: 'positive', text: 'Available' }]}
                    />
                    <InfoRow
                        title="Default Size"
                        value="$1,234.56"
                        size="default"
                    />
                    <InfoRow
                        title="Large Size"
                        value="$5,678.90"
                        size="large"
                    />
                    <InfoRow
                        title="Default Size with Badge"
                        value="Active"
                        size="default"
                        badges={[{ variant: 'positive', text: 'Verified' }]}
                    />
                    <InfoRow
                        title="Large Size with Badge"
                        value="Pending"
                        size="large"
                        badges={[{ variant: 'warning', text: 'Review' }]}
                    />
                    <InfoRow
                        title="Custom Value"
                        value={
                            <YStack>
                                <H6Regular>Custom ReactNode</H6Regular>
                            </YStack>
                        }
                    />
                    <InfoRow
                        title="With Info Icon"
                        value="Some information"
                        trailingIcon={InfoIcon}
                        onPress={() => {
                            console.log('Show info');
                        }}
                    />
                </YStack>
            </YStack>
        </YStack>
    );
};
